import { Plus } from '@/components/Icons'
import { PointerBubbleShell } from '@/components/PointerBubble/PointerBubbleShell'
import { cn } from '@/utils'

interface SelectionBubbleProps {
  position: { top: number; left: number }
  onAddComment: () => void
}

export const SelectionBubble = ({
  position,
  onAddComment,
}: SelectionBubbleProps) => {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation()
        onAddComment()
      }}
      className={cn(
        'absolute bg-transparent border-none hover:cursor-pointer focus:outline-none hover:scale-110'
      )}
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
        pointerEvents: 'auto',
      }}
      aria-label="Add comment"
      data-comment-add
    >
      <PointerBubbleShell className={cn('text-[var(--Colors-Brand-600)]')}>
        <Plus
          className="h-7 w-7 rounded-full text-[var(--Colors-Brand-600)]"
          style={{
            border: '2px solid var(--Component-colors-Alpha-alpha-black-10)',
            backgroundColor: 'white',
          }}
        />
      </PointerBubbleShell>
    </button>
  )
}
